module.exports = __webpack_public_path__ + "img/600.fcd4bef1.svg";